import {Schema} from 'schemas/SchemaConstants';

import {UnknownStructuredTable} from '../StructuredTableConstants';

export function doesUserHavePermissionToViewTable(structuredTable: UnknownStructuredTable): boolean {
  const knownSchemaIds: Array<string> = structuredTable.schemas.map(({id}: Schema) => id);
  const requiredSchemaIds: Array<string> = structuredTable.metadata.schemaMetadata.map(
    ({schemaId}) => schemaId
  );
  return requiredSchemaIds.every((id) => knownSchemaIds.includes(id));
}
